import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import './CategorySider.css';

const CategorySider = () => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/categories/`);
            const data = await response.json();
            if (data.success) setCategories(data.data);
            else setError('Failed to fetch categories');
        } catch (err) {
            setError('Error connecting to server');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const getImageUrl = (imagePath) => {
        if (!imagePath) return null;
        if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath;
        const path = imagePath.startsWith('/') ? imagePath.substring(1) : imagePath;
        const baseUrl = process.env.REACT_APP_BASE_URL.split('/api')[0];
        return `${baseUrl}/${path}`;
    };

    // ✅ FIXED: Pass category._id as the URL parameter and category.name as state
    const handleCategoryClick = (category) => {
        // Option 1: If products store category._id as a string
        navigate(`/category/${category._id}`, {
            state: {
                categoryName: category.name,
                categoryId: category._id
            }
        });

        // Option 2: If products store category.name as a string
        // Uncomment this and comment out the above if products use category names
        // navigate(`/category/${encodeURIComponent(category.name)}`, {
        //   state: { 
        //     categoryName: category.name,
        //     categoryId: category._id 
        //   }
        // });
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    if (loading) {
        return (
            <div className="category-sider-container">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading categories...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="category-sider-container">
                <div className="error-container">
                    <ShoppingBag />
                    <p>{error}</p>
                    <button onClick={fetchCategories}>Try Again</button>
                </div>
            </div>
        );
    }

    if (categories.length === 0) {
        return (
            <div className="empty-state">
                <ShoppingBag />
                <h3>No Categories Found</h3>
                <p>Categories will appear here once they are added.</p>
            </div>
        );
    }

    return (
        <div className="category-sider-container">
            <div className="category-sider-wrapper">
                <div className="category-sidebar-list">
                    {categories.map((category) => (
                        <div
                            key={category._id}
                            className="category-card-vertical"
                            onClick={() => handleCategoryClick(category)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="category-image-container-vertical">
                                <img
                                    src={getImageUrl(category.imageUrl) || '/api/placeholder/64/64'}
                                    alt={category.name}
                                    className="category-image-vertical"
                                    onError={(e) => { e.target.src = '/api/placeholder/64/64'; }}
                                />
                            </div>
                            <div className="category-info-vertical">
                                <h3 className="category-name-vertical">{category.name}</h3>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default CategorySider;